export const FETCH_SETTINGS = 'FETCH_SETTINGS';
export const FETCH_SETTINGS_FAIL = 'FETCH_SETTINGS_FAIL';
export const FETCH_SETTINGS_SUCCESS = 'FETCH_SETTINGS_SUCCESS';
export const ADD_CONTENT_TAG = 'ADD_CONTENT_TAG';
export const ADD_CONTENT_TAGS = 'ADD_CONTENT_TAGS';
export const ADD_CONTENT_TAG_SUCCESS = 'ADD_CONTENT_TAG_SUCCESS';
export const ADD_CONTENT_TAG_FAIL = 'ADD_CONTENT_TAG_FAIL';
export const UPDATE_SETTING = 'UPDATE_SETTING';
export const UPDATE_SETTING_SUCCESS = 'UPDATE_SETTING_SUCCESS';
export const UPDATE_SETTING_FAIL = 'UPDATE_SETTING_FAIL';
export const ADD_FUNNEL_STAGE = 'ADD_FUNNEL_STAGE';
export const ADD_FUNNEL_STAGES = 'ADD_FUNNEL_STAGES';
export const ADD_CONTENT_PRODUCT = 'ADD_CONTENT_PRODUCT';
export const ADD_CONTENT_PRODUCTS = 'ADD_CONTENT_PRODUCTS';
export const ADD_CONTENT_INDUSTRY = 'ADD_CONTENT_INDUSTRY';
export const ADD_CONTENT_INDUSTRIES = 'ADD_CONTENT_INDUSTRIES';
export const ADD_CONTENT_REGION = 'ADD_CONTENT_REGION';
export const ADD_CONTENT_REGIONS = 'ADD_CONTENT_REGIONS';
export const UPDATE_FUNNEL_STAGE = 'UPDATE_FUNNEL_STAGE';
export const UPDATE_CONTENT_PRODUCT = 'UPDATE_CONTENT_PRODUCT';
export const UPDATE_CONTENT_INDUSTRY = 'UPDATE_CONTENT_INDUSTRY';
export const UPDATE_CONTENT_REGION = 'UPDATE_CONTENT_REGION';
export const ADD_CONTENT_TYPE = 'ADD_CONTENT_TYPE';
export const ADD_CONTENT_TYPES = 'ADD_CONTENT_TYPES';
export const UPDATE_CONTENT_TYPE = 'UPDATE_CONTENT_TYPE';
export const UPDATE_CONTENT_TAG = 'UPDATE_CONTENT_TAG';
export const INVITE_USER = 'INVITE_USER';
export const DELETE_USER = 'DELETE_USER';
export const GET_USERS = 'GET_USERS';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_FAIL = 'GET_USERS_FAIL';
export const GET_USER_INFO = 'GET_USER_INFO';
export const GET_USER_INFO_SUCCESS = 'GET_USER_INFO_SUCCESS';
export const GET_USER_INFO_FAIL = 'GET_USER_INFO_FAIL';
export const DELETE_SETTINGS_ITEM = 'DELETE_SETTINGS_ITEM';
export const DELETE_SETTINGS_ITEM_SUCCESS = 'DELETE_SETTINGS_ITEM_SUCCESS';
export const DELETE_SETTINGS_ITEM_FAIL = 'DELETE_SETTINGS_ITEM_FAIL';
export const UPDATE_SHORT_DOMAIN = 'UPDATE_SHORT_DOMAIN';
export const UPDATE_SHORT_DOMAIN_FAIL = 'UPDATE_SHORT_DOMAIN_FAIL';
export const UPDATE_SHORT_DOMAIN_SUCCESS = 'UPDATE_SHORT_DOMAIN_SUCCESS';
export const SET_LOADING = 'SET_LOADING';
export const GET_INVOICES = 'GET_INVOICES';
export const GET_INVOICES_SUCCESS = 'GET_INVOICES_SUCCESS';
export const GET_INVOICES_FAIL = 'GET_INVOICES_FAIL';
export const UPDATE_ACCOUNT_APP_SETTINGS = 'UPDATE_ACCOUNT_APP_SETTINGS';
export const UPDATE_DIGEST_OPTION = 'UPDATE_DIGEST_OPTION';
export const UPDATE_DIGEST_OPTION_SUCCESS = 'UPDATE_DIGEST_OPTION_SUCCESS';
export const UPDATE_DIGEST_OPTION_FAIL = 'UPDATE_DIGEST_OPTION_FAIL';
export const CREATE_NEW_COLLECTION = 'CREATE_NEW_COLLECTION';
export const CREATE_NEW_COLLECTION_SUCCESS = 'CREATE_NEW_COLLECTION_SUCCESS';
export const CREATE_NEW_COLLECTION_FAIL = 'CREATE_NEW_COLLECTION_FAIL';
export const UPDATE_COLLECTION = 'UPDATE_COLLECTION';
export const DELETE_COLLECTION = 'DELETE_COLLECTION';
export const DELETE_COLLECTION_SUCCESS = 'DELETE_COLLECTION_SUCCESS';
export const DELETE_COLLECTION_FAIL = 'DELETE_COLLECTION_FAIL';
export const GET_COLLECTIONS = 'GET_COLLECTIONS';
export const GET_COLLECTIONS_SUCCESS = 'GET_COLLECTIONS_SUCCESS';
export const GET_COLLECTIONS_FAIL = 'GET_COLLECTIONS_FAIL';
export const GET_COLLECTION = 'GET_COLLECTION';
export const GET_COLLECTION_SUCCESS = 'GET_COLLECTION_SUCCESS';
export const GET_COLLECTION_FAIL = 'GET_COLLECTION_FAIL';
export const ADD_ITEM_TO_COLLECTION = 'ADD_ITEM_TO_COLLECTION';
export const REMOVE_ITEM_FROM_COLLECTION = 'REMOVE_ITEM_FROM_COLLECTION';
export const UPDATE_ITEMS_OF_COLLECTION = 'UPDATE_ITEMS_OF_COLLECTION';
export const CREATE_SITE = 'CREATE_SITE';
export const CREATE_SITE_SUCCESS = 'CREATE_SITE_SUCCESS';
export const CREATE_SITE_FAIL = 'CREATE_SITE_FAIL';
export const GET_USER_SITE_CONTENT = 'GET_USER_SITE_CONTENT';
export const GET_USER_SITE_CONTENT_SUCCESS = 'GET_USER_SITE_CONTENT_SUCCESS';
export const GET_USER_SITE_CONTENT_FAIL = 'GET_USER_SITE_CONTENT_FAIL';
export const DELETE_SITE = 'DELETE_SITE';
export const DELETE_SITE_SUCCESS = 'DELETE_SITE_SUCCESS';
export const DELETE_SITE_FAIL = 'DELETE_SITE_FAIL';
// v1 classic single branding logic
export const UPDATE_BRANDING_COLOR = 'UPDATE_BRANDING_COLOR';
export const UPDATE_BRANDING_COLOR_SUCCESS = 'UPDATE_BRANDING_COLOR_SUCCESS';
export const UPDATE_BRANDING_COLOR_FAILURE = 'UPDATE_BRANDING_COLOR_FAILURE';

export const UPDATE_TRACKERS = 'UPDATE_TRACKERS';
export const UPDATE_TRACKERS_SUCCESS = 'UPDATE_TRACKERS_SUCCESS';
export const UPDATE_TRACKERS_FAILURE = 'UPDATE_TRACKERS_FAILURE';
export const UPDATE_USER_ROLE = 'UPDATE_USER_ROLE';
export const UPDATE_USER_ROLE_SUCCESS = 'UPDATE_USER_ROLE_SUCCESS';
export const UPDATE_USER_ROLE_FAILURE = 'UPDATE_USER_ROLE_FAILURE';

export const fetchSettings = () => ({
  type: FETCH_SETTINGS
});

export const fetchSettingsFail = (error) => ({
  type: FETCH_SETTINGS_FAIL,
  error
});

export const fetchSettingsSuccess = (settings) => ({
  type: FETCH_SETTINGS_SUCCESS,
  settings
});

export const updateSettings = (id, listName, params) => ({
  type: UPDATE_SETTING,
  id,
  listName,
  params
});

export const updateSettingsSuccess = (id, params) => ({
  type: UPDATE_SETTING_SUCCESS,
  id,
  params
});

export const updateSettingsFail = (error) => ({
  type: UPDATE_SETTING_FAIL,
  error
});

export const addContentTag = (tag) => ({
  type: ADD_CONTENT_TAG,
  tag
});

export const addContentTagSuccess = (tag) => ({
  type: ADD_CONTENT_TAG_SUCCESS,
  tag
});

export const addContentTagFail = (error) => ({
  type: ADD_CONTENT_TAG_FAIL,
  error
});

export const addFunnelStage = (stage) => ({
  type: ADD_FUNNEL_STAGE,
  stage
});

export const addFunnelStages = (stages) => ({
  type: ADD_FUNNEL_STAGES,
  stages
});

export const addContentProduct = (product) => ({
  type: ADD_CONTENT_PRODUCT,
  product
});

export const addContentProducts = (products) => ({
  type: ADD_CONTENT_PRODUCTS,
  products
});

export const addContentIndustry = (industry) => ({
  type: ADD_CONTENT_INDUSTRY,
  industry
});

export const addContentIndustries = (industries) => ({
  type: ADD_CONTENT_INDUSTRIES,
  industries
});

export const addContentRegion = (region) => ({
  type: ADD_CONTENT_REGION,
  region
});

export const addContentRegions = (regions) => ({
  type: ADD_CONTENT_REGIONS,
  regions
});

export const updateFunnelStage = (stage) => ({
  type: UPDATE_FUNNEL_STAGE,
  stage
});

export const updateContentProduct = (product) => ({
  type: UPDATE_CONTENT_PRODUCT,
  product
});

export const updateContentIndustry = (industry) => ({
  type: UPDATE_CONTENT_INDUSTRY,
  industry
});

export const updateContentRegion = (region) => ({
  type: UPDATE_CONTENT_REGION,
  region
});

export const addContentType = (content) => ({
  type: ADD_CONTENT_TYPE,
  content
});

export const addContentTypes = (types) => ({
  type: ADD_CONTENT_TYPES,
  types
});

export const updateContentType = (content) => ({
  type: UPDATE_CONTENT_TYPE,
  content
});

export const updateContentTag = (tag) => ({
  type: UPDATE_CONTENT_TAG,
  tag
});

export const inviteUser = (params) => ({
  type: INVITE_USER,
  params
});

export const deleteUser = (id, email) => ({
  type: DELETE_USER,
  id,
  email
});

export const updateUserRole = (id, params) => ({
  type: UPDATE_USER_ROLE,
  id,
  params
})

export const getUsers = () => ({
  type: GET_USERS
});

export const getUsersSuccess = (users) => ({
  type: GET_USERS_SUCCESS,
  users
});

export const getUsersFail = (error) => ({
  type: GET_USERS_FAIL,
  error
});

export const getUserInfo = () => ({
  type: GET_USER_INFO
});

export const getUserInfoSuccess = (user) => ({
  type: GET_USER_INFO_SUCCESS,
  user
});

export const getUserInfoFail = (error) => ({
  type: GET_USER_INFO_FAIL,
  error
});

export const deleteSettingsItem = (params) => ({
  type: DELETE_SETTINGS_ITEM,
  params
});

export const deleteSettingsItemSuccess = (params) => ({
  type: DELETE_SETTINGS_ITEM_SUCCESS,
  params
});

export const deleteSettingsItemFail = (error) => ({
  type: DELETE_SETTINGS_ITEM_FAIL,
  error
});

export const updateShortDomain = (id, domainInfo) => ({
  type: UPDATE_SHORT_DOMAIN,
  id,
  domainInfo
});

export const updateShortDomainSuccess = (settings) => ({
  type: UPDATE_SHORT_DOMAIN_SUCCESS,
  settings
});

export const updateShortDomainFail = (error) => ({
  type: UPDATE_SHORT_DOMAIN_FAIL,
  error
});

export const setLoading = () => ({
  type: SET_LOADING
});

export const getInvoices = (customerId) => ({
  type: GET_INVOICES,
  customerId
});

export const getInvoicesSuccess = (invoices) => ({
  type: GET_INVOICES_SUCCESS,
  invoices
});

export const getInvoicesFail = (error) => ({
  type: GET_INVOICES_FAIL,
  error
});

export const updateAccountAppSettings = (payload) => ({
  type: UPDATE_ACCOUNT_APP_SETTINGS,
  payload
});

export const updateDigestOption = (digestOption) => ({
  type: UPDATE_DIGEST_OPTION,
  digestOption
});

export const updateDigestOptionSuccess = (settings) => ({
  type: UPDATE_DIGEST_OPTION_SUCCESS,
  settings
});

export const updateDigestOptionFail = (error) => ({
  type: UPDATE_DIGEST_OPTION_FAIL,
  error
});

export const createNewCollection = (params) => ({
  type: CREATE_NEW_COLLECTION,
  params
});

export const createNewCollectionSuccess = (userContent) => ({
  type: CREATE_NEW_COLLECTION_SUCCESS,
  userContent
});

export const createNewCollectionFail = error => ({
  type: CREATE_NEW_COLLECTION_FAIL,
  error
});

export const updateCollection = (id, params) => ({
  type: UPDATE_COLLECTION,
  id,
  params
});

export const deleteCollection = collection => ({
  type: DELETE_COLLECTION,
  collection
});

export const deleteCollectionSuccess = collection => ({
  type: DELETE_COLLECTION_SUCCESS,
  collection
});

export const deleteCollectionFail = error => ({
  type: DELETE_COLLECTION_FAIL,
  error
});

export const getCollections = () => ({
  type: GET_COLLECTIONS
});

export const getCollectionsSuccess = (collections) => ({
  type: GET_COLLECTIONS_SUCCESS,
  collections
});

export const getCollectionsFail = (error) => ({
  type: GET_COLLECTIONS_FAIL,
  error
});

export const getCollection = (id) => ({
  type: GET_COLLECTION,
  id
});

export const getCollectionSuccess = (collection) => ({
  type: GET_COLLECTION_SUCCESS,
  collection
});

export const getCollectionFail = (error) => ({
  type: GET_COLLECTION_FAIL,
  error
});

export const addItemToCollection = (itemId, collectionId) => ({
  type: ADD_ITEM_TO_COLLECTION,
  itemId,
  collectionId
});

export const removeItemFromCollection = (itemId, collectionId) => ({
  type: REMOVE_ITEM_FROM_COLLECTION,
  itemId,
  collectionId
});

export const updateItemsOfCollection = (items, collectionId, sharedBy, sharedWith) => ({
  type: UPDATE_ITEMS_OF_COLLECTION,
  items,
  collectionId,
  sharedBy,
  sharedWith
});

export const createSite = (params) => ({
  type: CREATE_SITE,
  params
});

export const createSiteSuccess = (site) => ({
  type: CREATE_SITE_SUCCESS,
  site
});

export const createSiteFail = (error) => ({
  type: CREATE_SITE_FAIL,
  error
});

export const getUserSiteContent = (userId, tenantId) => ({
  type: GET_USER_SITE_CONTENT,
  userId,
  tenantId
});

export const getUserSiteContentSuccess = (userContent) => ({
  type: GET_USER_SITE_CONTENT_SUCCESS,
  userContent
});

export const getUserSiteCOntentFail = (error) => ({
  type: GET_USER_SITE_CONTENT_FAIL,
  error
});

export const deleteSite = (id) => ({
  type: DELETE_SITE,
  id
});

export const deleteSiteSuccess = (userContent) => ({
  type: DELETE_SITE_SUCCESS,
  userContent
});

export const deleteSiteFail = (error) => ({
  type: DELETE_SITE_FAIL,
  error
});

// v1 classic single branding logic
export const updateBrandingColor = (color) => ({
  type: UPDATE_BRANDING_COLOR,
  color
});

export const updateTrackers = (data) => ({
  type: UPDATE_TRACKERS,
  params: data
})
